import React, { useState, useEffect } from "react"
import { Link } from "@reach/router"
import { makeStyles } from "@material-ui/core/styles"
import MenuItem from "@material-ui/core/MenuItem"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import trees from "../static/trees-1.jpg"
import kila from "../static/kila.png"

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 130,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
}))

const ComplianceSideNav = props => {
  const classes = useStyles()

  const [data, setData] = useState({})

  return (
    <div>
      <ul id="slide-out" className="sidenav">
        <li>
          <div className="user-view">
            <div className="background">
              <img src={trees} width="300" height="300" alt="background" />
            </div>
            <div className="user-img">
              {/* <Link to="/mi-perfil/">
                <img className="circle" src={data.image} alt="user" />
              </Link> */}
              <img className="kila-logo" src={kila} alt="kila-logo" />
            </div>
            <Link to="/mi-perfil/">
              <span className="white-text usuario">{data.building_name}</span>
            </Link>
            {/* <Link to="/mi-perfil/">
              <span className="white-text email obra">Ir a Perfil</span>
            </Link> */}
          </div>
        </li>
        {/* <li>
          <span className="contract">
            <i className="material-icons">book</i>Número de Contrato:{" "}
            {data.contract_number}
          </span>
        </li>
        <li>
          <Link to="/mi-perfil/" className="indices">
            <span>
              <i className="material-icons">assessment</i>
              <span className="indices-title">
                Indices de Cumplimiento Sapal
              </span>
            </span>
          </Link>
        </li> */}
        <li>
          <div className="divider"></div>
        </li>
        <li>
          <a href="#!" className="subheader">
            Opciones
          </a>
        </li>
        <li className="weeks">
          <FormControl className={classes.formControl}>
            <Select
              value={props.week}
              onChange={props.handleChange}
              displayEmpty
              className={classes.selectEmpty}
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="">
                <em>Seleccionar Semana</em>
              </MenuItem>
              {props.weeks.map((item, key) => (
                <MenuItem key={key} value={item}>
                  Semana {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </li>
        <li>
          <span>
            <Link className="goto" to={`/building/${props.page}`}>
              Volver a la Obra
              <span role="img" aria-label="house">
                &nbsp;🍃
              </span>
            </Link>
          </span>
        </li>
      </ul>
    </div>
  )
}

export default ComplianceSideNav
